import {LocationDto} from "../../../models/location-dto";
import {CashPointEntryDto} from "./cash-point-entry-dto";

export class LocationCashPointLinker {
  location: LocationDto;
  cpes: CashPointEntryDto[];

  constructor(location: LocationDto, cpes: CashPointEntryDto[] | undefined) {
    this.location = location;
    this.cpes = cpes || [];
  }
}
